import { func, string } from 'prop-types'

import scope from 'recompose-scope/composeWithScope'
import consumeProps from 'recompose-scope/consumeProps'
import exposeProps from 'recompose-scope/exposeProps'

import withState from 'recompose/withState'
import withProps from 'recompose/withProps'
import withHandlers from 'recompose/withHandlers'

import objectEditorEnhancer from 'coact/objectEditorEnhancer'

import InputSettingView from './InputSetting'

const InputSetting = scope(
  consumeProps({
    extendRange: func.isRequired,
    method: string,
  }),

  withState('value', 'onChange', { }),
  withProps({
    schema: {
      type: 'object',
      contents: {
        s1: { type: 'number' },
        s2: { type: 'number' },
        c1: { type: 'number' },
        c2: { type: 'number' },
      },
    },
  }),

  objectEditorEnhancer,


  withProps(({ method }) => ({
    hideWhenMethodIsDot: method === 'dot' ? { display: 'none' } : {},
  })),
  withHandlers({
    fillGrids: ({ extendRange, value }) => () => {
      const { s1, s2, c1, c2 } = value
      extendRange({
        fromCell: { s: s2 * 100, c: c2 * 100 },
        toCell: { s: s1 * 100, c: c1 * 100 },
      })
    },
  }),

  exposeProps([
    'schema',
    'value',
    'onChange',
    'spliter',
    'fillGrids',
    'hideWhenMethodIsDot',
  ]),
)(InputSettingView)
InputSetting.displayName = 'InputSetting'

export default InputSetting



// WEBPACK FOOTER //
// ./src/components/RangeEditor/InputSetting/index.js